import { router } from 'expo-router';
import { ScrollView, XStack } from 'smoothie';

import { useAuthedUser } from '../../../common/providers/AuthedUserProvider';
import { getNonTerminatedCardsForUser } from '../../../common/utils/cardUtils';
import { type Card } from '../../types/Card';
import { FruitfulCardSummary } from './FruitfulCard';

interface CardSummariesProps {
    syncteraAccountId: string;
    cards: Card[];
}

const CardSummaries = ({ syncteraAccountId, cards }: CardSummariesProps) => {
    const user = useAuthedUser();
    const filteredCards = getNonTerminatedCardsForUser(
        user.syncteraPersonId,
        cards,
    );

    return (
        <ScrollView
            horizontal
            showsHorizontalScrollIndicator={false}
            // In a parent with alignItems: 'flex-start', a horizontal ScrollView
            // otherwise shrink-wraps to the full content width, so on web and native
            // there is no horizontal overflow to scroll (sibling cards are clipped).
            style={{ width: '100%', minWidth: 0, alignSelf: 'stretch' }}
            contentContainerStyle={
                filteredCards.length === 1
                    ? { minWidth: '100%', justifyContent: 'center' }
                    : undefined
            }
            nestedScrollEnabled
        >
            <XStack gap={12}>
                {filteredCards.map(
                    (
                        {
                            id,
                            form,
                            color,
                            lastFour,
                            embossName,
                            cardStatus,
                            userCardStatusReason,
                        },
                        index,
                    ) => {
                        const isLast = index === filteredCards.length - 1;

                        return (
                            <FruitfulCardSummary
                                key={id}
                                cardholderName={embossName.line1}
                                form={form}
                                color={color}
                                lastFour={lastFour}
                                cardStatus={cardStatus}
                                userCardStatusReason={userCardStatusReason}
                                onPress={() => {
                                    router.navigate({
                                        pathname: '/banking/card/manage-card',
                                        params: {
                                            syncteraAccountId,
                                            cardId: id,
                                        },
                                    });
                                }}
                                {...(isLast ? { marginRight: 16 } : {})}
                            />
                        );
                    },
                )}
            </XStack>
        </ScrollView>
    );
};

export default CardSummaries;
